import React from 'react'
import { Link } from 'react-router-dom'
import CurrencyFormat from "react-currency-format"
import LazyLoad from 'react-lazy-load'
import ProgressiveImage from 'react-progressive-graceful-image'
import { LAZY_L, NO_IMAGE, IMAGE_THUMB, SIZE_IMAGE_THUMB } from 'constants/general'

import { repareImage } from 'functions/repareDataService'
import { useDispatch } from 'context/storeProvider'
import { TYPES } from 'context/storeReducer'

import StarsFive from 'components/StarsFive'
import BtnWishlist from 'components/Wishlist'

export default function CardRecomendation(props) {
    const {
        id,
        nombre,
        precio,
        precioLista,
        foto,
        descuento,
        link,
        priority = "low",
        productTotal
    } = props

    const dispatch = useDispatch()

    let newFoto, placeH
    if (foto?.indexOf('?') >= 0) {
        placeH = repareImage(foto)+`&scale=${SIZE_IMAGE_THUMB}`
        newFoto = repareImage(foto)+`&scale=350`
        //newFoto = foto
    } else {
        placeH = repareImage(foto)+`?scale=${SIZE_IMAGE_THUMB}`
        newFoto = repareImage(foto)+`?scale=350`
        //newFoto = foto
    }

    const clickCard = () =>{
        // console.log('productTotal: ',productTotal)
        dispatch({type: TYPES.UPDATE_PRODUCT, payload: productTotal ? productTotal : {} })
        window.sessionStorage.setItem("productTotal",  JSON.stringify(productTotal ? productTotal : {}) )
    }

    return (
        <article className="cardRecomended" data-scarabitem={id}>
            {/* <BtnWishlist id={id}/> */}
            <Link to={link} title={nombre}>
                <div>
                    <div className="h4P"><span>{nombre}</span></div>
                    {IMAGE_THUMB
                        ?
                            <ProgressiveImage
                                src={foto != null ? newFoto : NO_IMAGE}
                                placeholder={foto != null ? placeH : NO_IMAGE}
                            >
                                {(src) => <img
                                    src={src}
                                    alt={nombre}
                                    width="230"
                                    height="230"
                                    decoding="async"
                                    loading="lazy"
                                    fetchpriority={priority}
                                />
                                }
                            </ProgressiveImage>
                        :
                            <img
                                src={foto != null ? newFoto : NO_IMAGE}
                                alt={nombre}
                                width="230"
                                height="230"
                                decoding="async"
                                loading="lazy"
                                fetchpriority={priority}
                            />
                    
                    }
                    <div className="info">
                        <CurrencyFormat
                            value={precioLista}
                            displayType={'text'}
                            thousandSeparator={true} prefix={'$'} renderText={value => <p className="precioPrincipal">{value}<span className="mxn"></span>
                                {/* {descuento <= HIDDEN_DISCOUNT ? null  : <span className="discoutnCard">-{descuento}%</span> } */}
                            </p>}
                        />
                        {/* <div className="priceDiscountContent"> */}
                        {descuento !== 0 && precioLista !== precio
                            ?
                            <CurrencyFormat
                                value={precio}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'$'}
                                renderText={value => <p className="textUnderline conDiscount">{value}</p>}
                            />
                            : null
                        }
                        {/* </div> */}
                    </div>
                </div>
            </Link>
        </article>
    )
}